export var VideoSource = /*#__PURE__*/ function(VideoSource) {
    VideoSource["Youtube"] = "youtube";
    VideoSource["Vimeo"] = "vimeo";
    VideoSource["Loom"] = "loom";
    VideoSource["Unsupported"] = "unsupported";
    return VideoSource;
}({});
export const videoPlayerBorderRadius = '8px';
export const getVideoSource = (parsedVideoLink)=>{
    const hostname = parsedVideoLink.hostname;
    const youtubeHostnames = [
        'www.youtube.com',
        'youtube.com',
        'youtu.be'
    ];
    const vimeoHostname = [
        'vimeo.com'
    ];
    const loomHostnames = [
        'www.loom.com',
        'loom.com'
    ];
    if (youtubeHostnames.includes(hostname)) {
        return "youtube";
    } else if (vimeoHostname.includes(hostname)) {
        return "vimeo";
    } else if (loomHostnames.includes(hostname)) {
        return "loom";
    } else {
        return "unsupported";
    }
};
export function sanitizeUrl(url, videoSource) {
    if (videoSource === "youtube") {
        const parsedUrl = new URL(url);
        const videoIdKey = 'v';
        const playlistIdKey = 'list';
        if (parsedUrl.searchParams.has(videoIdKey)) {
            parsedUrl.searchParams.delete(playlistIdKey);
        }
        return parsedUrl.toString();
    }
    return url;
}
export function extractReactPlayerVideoName(videoLink, reactPlayer) {
    const source = getVideoSource(new URL(videoLink));
    const internalPlayer = reactPlayer.getInternalPlayer();
    if (source === "youtube") {
        var _internalPlayer_getVideoData;
        return (_internalPlayer_getVideoData = internalPlayer.getVideoData) === null || _internalPlayer_getVideoData === void 0 ? void 0 : _internalPlayer_getVideoData.call(internalPlayer).title;
    }
    if (source === "vimeo") {
        var _internalPlayer_element;
        return (_internalPlayer_element = internalPlayer.element) === null || _internalPlayer_element === void 0 ? void 0 : _internalPlayer_element.title;
    }
    throw new Error('Unsupported video source');
}
